export const GNOSIS_MAIN_HTTP =
  "https://rpc.ankr.com/gnosis/446e0d733511e245621153f48748ebc3f56e7cedb3c3766f96e819146256aa80";

export const GNOSIS_MAIN_WS =
  "wss://rpc.ankr.com/gnosis/ws/446e0d733511e245621153f48748ebc3f56e7cedb3c3766f96e819146256aa80";
